import { Injectable } from '@angular/core';
import Dexie, { Table } from 'dexie';
import { IpcService } from './ipc.service';
import { LoadLocation } from 'interfaces/common/db/models/load-location';
import { ZipcodeData } from '../@enums/ZipcodeData.type';
import { DrayageFrontend } from '../interfaces/Drayage.interface';
import { Company } from 'interfaces/common/db/models/companies';
import { User } from 'interfaces/common/db/models/auth';

@Injectable({
  providedIn: 'root'
})
export class DbService extends Dexie {
  public locations: Table<LoadLocation>;
  public drayages: Table<DrayageFrontend>;
  public zipcodeData: Table<{
    zipcode: string;
    data: ZipcodeData;
  }>;
  public companies: Table<Company>;
  public users: Table<User>;

  constructor(public ipc: IpcService) {
    super('dexcarga');

    this.version(1).stores({
      locations: '&name, _id',
      zipcodeData: '&zipcode',
      drayages: '&_id, &uniqueId, createdAt, updatedAt',
      companies: '&_id, identity.name',
      users: '&_id'
    });
  }

  
}
